import { reconnectAllMercureConnections } from '@/lib/helpers/subscribeToMercureTopic'

/** Mirrors MercureAuthorizationCookieSubscriber::FINGERPRINT_HEADER. */
export const MERCURE_CLAIMS_HEADER = 'X-Mercure-Claims'

let lastSeen: string | null = null

/**
 * Called with the X-Mercure-Claims value of every /maintenance-status response.
 *
 * The response that carries a NEW value also carries the reissued cookie, so reconnecting right
 * after it picks the new claims up. The first value seen reconnects too: streams opened on page
 * load use whatever cookie the browser held then, which after a deploy or a secret rotation is the
 * one this response just replaced. A reconnect when nothing changed costs one round trip.
 */
export function observeMercureClaims(value: string | null): void {
  if (!value) return
  const previous = lastSeen
  lastSeen = value
  if (previous !== value) {
    reconnectAllMercureConnections()
  }
}

/** Test seam. */
export function resetMercureClaimsWatch(): void {
  lastSeen = null
}
